import { ACTION_LOGOUT } from "app/modules/login/reducer/actions.type";
import {
  FETCH_LIST_ACCOUNT_REQUEST,
  FETCH_LIST_ACCOUNT_SUCCESS,
  FETCH_LIST_ACCOUNT_FAILURE,
  FETCH_LIMIT_REMAIN_REQUEST,
  FETCH_LIMIT_REMAIN_SUCCESS,
  FETCH_LIMIT_REMAIN_FAILURE,
  FETCH_ACCOUNT_DETAIL_REQUEST,
  FETCH_ACCOUNT_DETAIL_SUCCESS,
  FETCH_ACCOUNT_DETAIL_FAILURE,
  FETCH_LIST_ACCOUNT_LOGIN_FAILURE,
  FETCH_LIST_ACCOUNT_LOGIN_REQUEST,
  FETCH_LIST_ACCOUNT_LOGIN_SUCCESS,
  FETCH_CUSTOMER_POSITION_REQUEST,
  FETCH_CUSTOMER_POSITION_SUCCESS,
  FETCH_CUSTOMER_POSITION_FAILURE,
  SET_CONTACT_ID_STORE,
} from "./actions.type";

import { AccountActions, AccountState } from "./types";

const initialState: AccountState = {
  // check key
  hasKey: undefined,
  // list acccount
  statusListAccountLogin: "init",
  USERPROFILE: undefined,
  LIST_ACCOUNT_PROFILE: undefined,
  statusListAccount: "init",
  errorListAccount: {
    code: "",
    message: "",
  },
  // limit remain
  statusLimitRemain: "init",
  LIMIT_REMAIN: undefined,
  errorLimitRemain: undefined,
  //account detail
  statusAccountDetail: "init",
  ACCOUNTPROFILE: undefined,
  errorAccountDetail: undefined,
  // Customer position
  statusCustomerPosition: "init",
  LIST_ACCOUNT_CUSTOMER: undefined,
  errorCustomerPosition: undefined,
  hashContactId: undefined,
};

export default (state = initialState, action: AccountActions): AccountState => {
  switch (action.type) {
    // LIST ACCOUNT AND LOYALTY
    case FETCH_LIST_ACCOUNT_LOGIN_REQUEST:
      return {
        ...state,
        LIST_ACCOUNT_PROFILE: undefined,
        statusListAccountLogin: "pending",
      };
    case FETCH_LIST_ACCOUNT_LOGIN_SUCCESS:
      return {
        ...state,
        ...action.payload,
        hasKey: action.hasKey,
        signature: action.signature,
        statusListAccountLogin: "ok",
      };
    case FETCH_LIST_ACCOUNT_LOGIN_FAILURE:
      return {
        ...state,
        statusListAccountLogin: "error",
      };
    // LIST ACCOUNT
    case FETCH_LIST_ACCOUNT_REQUEST:
      return {
        ...state,
        statusListAccount: "pending",
      };
    case FETCH_LIST_ACCOUNT_SUCCESS:
      return {
        ...state,
        ...action.payload,
        hasKey: action.hasKey,
        signature: action.signature,
        statusListAccount: "ok",
      };
    case FETCH_LIST_ACCOUNT_FAILURE:
      return {
        ...state,
        statusListAccount: "error"
      };

    // ACCOUNT DETAIL
    case FETCH_ACCOUNT_DETAIL_REQUEST:
      return {
        ...state,
        ACCOUNTPROFILE: undefined,
        statusAccountDetail: "pending",
      };
    case FETCH_ACCOUNT_DETAIL_SUCCESS:
      return {
        ...state,
        ACCOUNTPROFILE: action.payload,
        statusAccountDetail: "ok",
      };
    case FETCH_ACCOUNT_DETAIL_FAILURE:
      return {
        ...state,
        statusAccountDetail: "error",
      };
    // LIMIT REMAIN
    case FETCH_LIMIT_REMAIN_REQUEST:
      return {
        ...state,
        statusLimitRemain: "pending",
      };
    case FETCH_LIMIT_REMAIN_SUCCESS:
      return {
        ...state,
        LIMIT_REMAIN: action.payload,
        statusLimitRemain: "ok",
      };
    case FETCH_LIMIT_REMAIN_FAILURE:
      return {
        ...state,
        statusLimitRemain: "error",
      };
    // Customer Position
    case FETCH_CUSTOMER_POSITION_REQUEST:
      return {
        ...state,
        statusCustomerPosition: "pending",
      };
    case FETCH_CUSTOMER_POSITION_SUCCESS:
      return {
        ...state,
        LIST_ACCOUNT_CUSTOMER: action.payload,
        statusCustomerPosition: "ok",
      };
    case FETCH_CUSTOMER_POSITION_FAILURE:
      return {
        ...state,
        statusCustomerPosition: "error",
      };
    case SET_CONTACT_ID_STORE:
      return {
        ...state,
        hashContactId: action.payload,
      };
    // LOGOUT
    case ACTION_LOGOUT:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};
